import { render, staticRenderFns } from "./DashboardTv.vue?vue&type=template&id=be2dac7e"
import script from "./DashboardTv.vue?vue&type=script&lang=ts"
export * from "./DashboardTv.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTv.vue?vue&type=style&index=0&id=be2dac7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports